import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Product, ProductOption, ProductsState } from './types'

const initialState: ProductsState = {
  list: [],
  options: {
    game: [],
    slot: [],
  },
  loading: true,
}

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProducts(state, action: PayloadAction<Product[]>) {
      state.list = action.payload
      state.loading = false
    },
    setProductsLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setProductOptions(
      state,
      action: PayloadAction<{ [key: string]: ProductOption[] }>,
    ) {
      state.options = action.payload
      state.loading = false
    },
  },
})

export default productsSlice.reducer

export const { setProducts, setProductsLoading, setProductOptions } =
  productsSlice.actions
